import Header from "./Header";

export const EcoblazeComponents: { [key: string]: any } = {
    Header: Header
};
